import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import img1 from '../assests/gallery/Manimuthar-Falls-2.webp'
import img2 from '../assests/gallery/Suchindram-temple.webp'
import img3 from '../assests/gallery/Tiger-Reserve-1.webp'
import img4 from '../assests/gallery/Old-Temple-Tirunelveli.webp'
import img5 from '../assests/gallery/destinations-to-relax-with-family-in-tamil-nadu.avif'
import img6 from '../assests/gallery/shutterstock_1504345622-2.webp'

export default function Home(){
  const images = [img1, img2, img3, img4, img5, img6]
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % images.length), 5000)
    return () => clearInterval(t)
  }, [images.length])

  return (
    <main>
      <section className="hero" style={{backgroundImage:`url(${images[idx]})`, backgroundSize:'cover', backgroundPosition:'center'}}>
        <div className="hero-overlay" />
        <div className="container hero-inner">
          <h1>Cab Service in Tirunelveli, Tenkasi, Kutrallam</h1>
          <p className="lead">Experience the enchanting beauty of Southern Tamil Nadu’s hidden gems with our premier car services. From the medicinal waters of Courtallam (Kutralam) to the serene Agasthiyar Falls, majestic Manimuthar Dam, and scenic Karaiyar, we provide safe, comfortable, and reliable transport for your unforgettable journey around Tenkasi and Tirunelveli. 
Why Choose Our Travel Services?
Customized Sightseeing Packages: Tailored trips covering top spots including Kutralam Falls, Manimuthar Falls, Agasthiyar Falls, Karaiyar Dam, and Manjolai Hills.
Safe & Comfortable Fleet: Well-maintained cars for hilly terrain and scenic drives.
Local Expertise: Experienced drivers familiar with the best spots in the Western Ghats. 
Book Your Perfect Southern Getaway Today!
Explore the Kasi Viswanathar Temple in Tenkasi and the sacred sites around Tirunelveli with ease. Whether it's a family trip or an adventurous getaway to the Kalakkad Mundanthurai Tiger Reserve, we make your travel seamless. 
Contact us for competitive rates and premium travel experiences.
</p>
          <div className="hero-cta">
            <a className="btn primary" href="/explore">Explore Trips</a>
            <a className="btn" href="/enquire">Enquire via WhatsApp</a>
          </div>
        </div>
      </section>

      <section className="features container">
        <h2>Why Travel Trip Journey?</h2>
        <div className="grid">
          {[
            {title: 'Curated Trips', text: 'Ready-to-book plans for all budgets.', to: '/explore'},
            {title: 'Local Guides', text: 'Trusted partners and personalized itineraries.', to: '/enquire'},
            {title: 'Photo Stories', text: 'Browse real photos from past trips.', to: '/gallery'}
          ].map((c, i) => (
            <div key={i} className="card">
              <h3>{c.title}</h3>
              <p>{c.text}</p>
              <Link className="read-more" to={c.to}>Read more →</Link>
            </div>
          ))}
        </div>
      </section>
    </main>
  )
}
